import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Linkedin, Mail } from "lucide-react";
import { BRAND, CONTACT, NAV_LINKS } from "../lib/constants";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#FAF6F0] border-t border-[#B5896E]/15 mt-24">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-16 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3 mb-6">
            <span className="relative inline-block w-9 h-9">
              <span className="absolute inset-0 rounded-full border border-[#B5896E]/60" />
              <span className="absolute inset-[5px] rounded-full bg-gradient-to-br from-[#B5896E] to-[#D4A88E]" />
            </span>
            <span className="font-display text-2xl">{BRAND.name}</span>
          </div>
          <p className="text-sm text-[#4A3F35]/60 leading-relaxed max-w-sm">
            {BRAND.tagline}. A B2B sourcing platform connecting jewelry retailers to India's
            finest craftsmanship — and the world's most discerning buyers.
          </p>
          <div className="mt-6">
            <div className="caption mb-3">Branches</div>
            <div className="flex flex-wrap gap-2">
              {CONTACT.branches.map((b) => (
                <span key={b} data-testid={`footer-branch-${b.toLowerCase()}`} className="px-3 py-1.5 text-xs tracking-[0.18em] uppercase text-[#4A3F35]/75 border border-[#B5896E]/30 rounded-full bg-white/40">
                  {b}
                </span>
              ))}
            </div>
          </div>
        </div>
        <div className="md:col-span-3">
          <div className="caption mb-5">Navigate</div>
          <ul className="space-y-3">
            {NAV_LINKS.map((l) => (
              <li key={l.to}>
                <Link
                  data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  to={l.to}
                  className="text-sm text-[#4A3F35]/75 hover:text-[#B5896E] transition-colors"
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="caption mb-5">Reach Us</div>
          <ul className="space-y-3 text-sm text-[#4A3F35]/75">
            <li>{CONTACT.addressLine1}</li>
            <li>{CONTACT.addressLine2}</li>
            <li className="pt-2">
              <a href={`mailto:${CONTACT.email}`} className="hover:text-[#B5896E]">{CONTACT.email}</a>
            </li>
            {CONTACT.phones.map((p) => (
              <li key={p.label}>{p.label}: {p.number}</li>
            ))}
          </ul>
          <div className="flex items-center gap-4 mt-6">
            <a data-testid="footer-instagram" href={CONTACT.instagram} target="_blank" rel="noopener noreferrer" className="w-10 h-10 grid place-items-center border border-[#B5896E]/25 rounded-full hover:border-[#B5896E] hover:text-[#B5896E] transition-colors">
              <Instagram size={16} />
            </a>
            <a data-testid="footer-linkedin" href={CONTACT.linkedin} target="_blank" rel="noopener noreferrer" className="w-10 h-10 grid place-items-center border border-[#B5896E]/25 rounded-full hover:border-[#B5896E] hover:text-[#B5896E] transition-colors">
              <Linkedin size={16} />
            </a>
            <a href={`mailto:${CONTACT.email}`} className="w-10 h-10 grid place-items-center border border-[#B5896E]/25 rounded-full hover:border-[#B5896E] hover:text-[#B5896E] transition-colors">
              <Mail size={16} />
            </a>
          </div>
        </div>
      </div>
      <div className="border-t border-[#B5896E]/10">
        <div className="max-w-[1400px] mx-auto px-6 lg:px-12 py-6 flex flex-col md:flex-row items-center justify-between gap-3 text-xs text-[#4A3F35]/50">
          <span>© 2025 {BRAND.legalName}. All rights reserved.</span>
          <span className="tracking-[0.2em] uppercase">Crafted in India · Sourced for the world</span>
        </div>
      </div>
    </footer>
  );
}
